import $ from 'jquery';
import { notification } from './utility';

$('button[name="jsAddCart"]').on('click', function (e) {
  e.preventDefault();
  const data = $('form[name="formDetailAddCart"]').serializeArray();
  let itemId = 0;
  let totalItem = 1;
  let langCode = 'vn';
  let price = null;
  const dataTypeGroupIds = data?.filter((e) => e?.name === 'typeGroupIds[]');
  const typeGroupIds = [];
  if (dataTypeGroupIds && dataTypeGroupIds?.length !== 0) {
    // Get list typeGroup
    dataTypeGroupIds.forEach((element) => {
      typeGroupIds.push(element?.value || 0);
    });
  }

  let emptyCount = 0;
  const typeIds = [];
  typeGroupIds.forEach((element) => {
    const temp = data.find((e) => e?.name === element);
    if (temp && temp?.value && temp?.value !== '0') {
      typeIds.push(temp);
    } else {
      emptyCount += 1;
      $('.required-noti[data-id=' + element + ']').html(
        'Vui lòng chọn dữ liệu',
      );
      $('.required-noti[data-id=' + element + ']').addClass('error');
    }
  });

  if (emptyCount !== 0) {
    // Chưa chọn đủ dữ liệu bán hàng
    $('.required-noti.all').html('');
    return;
  }

  data.map(function (elm) {
    switch (elm.name) {
      case 'id':
        itemId = elm.value;
        break;
      case 'detailNumAddCart':
        totalItem = elm.value;
        break;
      case 'lang_code':
        langCode = elm.value;
        break;
      case 'price':
        price = elm.value;
        break;
      default:
        break;
    }
  });

  $('.required-noti').html('');
  addToCartInList(itemId, totalItem, langCode, typeIds, price);
});

function addToCartInList(itemId, totalItem, langCode, typeIds = [], price) {
  $.ajax({
    type: 'POST',
    url: APP_URL + '/api/cart/add',
    dataType: 'json',
    data: {
      id: itemId,
      soLuong: totalItem,
      langCode: langCode,
      typeIds: typeIds,
      price: price,
    },
    success: function (resposive) {
      const res = JSON.parse(resposive);
      if (res && res?.data) {
        notification('SUCCESS', 'Đã thêm 1 sản phẩm vào giỏ!');
        $('#totalAmount').html(res?.data);
        // $('#showdonhang').show(0).delay(400).hide(200);
      }
    },
  });
}

$('.js-input-quantity').on('change', function (e) {
  const id = e.currentTarget.dataset?.id;
  const price = e.currentTarget.dataset?.price;
  var tongdau = document.getElementById('tong' + id).value;
  var so_luong = document.getElementById('quatity' + id).value;
  var tongall = document.getElementById('tongfix').value;
  for (var i = 0; i < tongdau.length; i++) tongdau = tongdau.replace('.', '');
  for (var i = 0; i < tongdau.length; i++) tongall = tongall.replace('.', '');
  tongdau = parseInt(tongdau);
  tongall = parseInt(tongall);
  if (so_luong == '') {
    so_luong = 1;
  } else if (so_luong == 0) {
    so_luong = 1;
  }

  var so_luong_new = parseInt(so_luong);
  var totalnew = parseInt(price * so_luong_new);
  var totalnewnew = totalnew;
  document.getElementById('tong' + id).value = totalnewnew
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  var tongfix = parseInt(totalnew - tongdau);
  var tongshow = parseInt(tongall + tongfix);
  var tongshownew = tongshow;
  document.getElementById('tongfix').value = tongshownew
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  $.ajax({
    type: 'GET',
    url: APP_URL + '/api/cart/update',
    data: { id: id, soLuong: so_luong },
  });
});
